import {
  Box, Grid, Label, Text,
} from '@usealloy/component-library';
import styled from 'styled-components';

export const ChooseFileLabel = styled(Label)`
  &&&& {
    color: var(--cl-juicyBlue-600);
    cursor: pointer;
    display: inline-block;
  }
`;

export const ChooseFileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

export const TargetDropBox = styled(Box)`
  height: 200px;
  border: dashed 1.3px var(--cl-gray-500);
  background-color: var(--cl-gray-200);
  border-radius: var(--cl-radius-4);

  &.drag-over {
    border-color: var(--cl-juicyBlue-600);
    background-color: var(--cl-juicyBlue-50);
  }
`;

export const CloudUploadIconWrapper = styled(Box)`
  border: 2px solid var(--cl-juicyBlue-600);
  border-radius: var(--cl-radius-2);
  max-height: min-content;
  max-width: min-content;
  padding: 7px;
`;

export const UploadInfo = styled(Text)`
  &&&& {
    color: var(--cl-gray-600);
    display: inline-block;
    font-size: var(--cl-font-size-1);
  }
`;

export const FileNameWrapper = styled(Box)`
  border: 1px solid var(--cl-green-300);
  border-radius: var(--cl-radius-2);
  max-height: var(--cl-space-10);
  min-height: var(--cl-space-10);
  padding: var(--cl-space-2);
  text-wrap: nowrap;
`;

export const FileRowGrid = styled(Grid)`
  &&&& {
    grid-template-columns: repeat(10, minmax(0, 1fr));
    min-width: 100%;
  }
`;

export const TruncatedFileNameText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
